import { createSlice } from '@reduxjs/toolkit'

import { authSelectors } from '../selectors/auth'

const initialState = {
    username: '',
    isAuthorized: false,
    isLoading: false,
    error: null,
}

const auth = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuthLoading: (state, action) => {
            state.isLoading = action.payload
        },
        setAuthSuccess: (state, action) => {
            state.username = action.payload.username
            state.isAuthorized = true
            state.error = null
        },
        setAuthError: (state, action) => {
            state.error = action.payload
            state.isAuthorized = false
        },
        resetAuth: () => initialState,
    },
    selectors: {
        ...authSelectors,
    },
})

export const authSelector = auth.getSelectors()
export const authActions = auth.actions

export default auth.reducer
